// ======================================================================
// File Name       : ContentLinkDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { Form, Col, Button } from 'react-bootstrap';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import ContentLinkDetail from '../../components/content/ContentLinkDetail';
import DialogConfirm from '../../components/DialogConfirm';
import { searchContentLinkList, contentLinkEdit } from '../../actions/content/ContentLinkAction';
import { SELECT_TARGET_DATA, MODE } from '../../constants/index';
import { getUserQuery } from '../../utils/SessionStorageUtils';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { CONTENT_LINK_EDIT } from '../../constants/FunctionConstants';
import { shouldHideBackBtn } from '../../utils/index';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';

class ContentLinkDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentLinkInfo: {
        linkContentList: [],
      },
      redirectToList: false,
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
  }

  componentDidMount() {
    this.getContentLinkList();
  }

  componentWillReceiveProps(nextProps) {
    const { content, match, redirectToList } = nextProps;
    const { contentLinkInfo } = content;
    const contentLinkDetail = contentLinkInfo &&
    contentLinkInfo.linkContentList && $.grep(
      contentLinkInfo.linkContentList,
      e => e.contentSecernId === match.params.id,
    );
    if (contentLinkDetail && contentLinkDetail.length > 0) {
      this.setState({
        contentLink: contentLinkDetail[0],
        redirectToList,
      });
    }
  }

  getContentLinkList() {
    const { match } = this.props;
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        contentSecernIdList: match.params.id ? [match.params.id] : [],
      },
    };
    this.props.dispatch(searchContentLinkList(param));
  }

  /**
   * Open delete confirm dialog
   * @param {*} mdContent
   * @param {*} mdSize
   */
  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
   * Event click button cancel of delete confirm dialog
   */
  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  /**
   * Event click button ok of delete confirm dialog
   */
  onDeleteOk() {
    this.setState({ showModal: false });
    const param = {
      editType: MODE.DELETE_MODE,
      linkContentInfo: {
        contentSecernId: this.state.contentLink.contentSecernId,
        contentName: this.state.contentLink.contentName,
        linkUrl: this.state.contentLink.linkUrl,
      },
    };
    this.props.dispatch(contentLinkEdit(param)).then(() => {
      this.props.history.push(Path.CONTENT_LINK_LIST);
    });
  }

  render() {
    const editPath = this.state.contentLink
      ? `/${Path.CONTENT}/${Path.CONTENT_LINK}/${this.state.contentLink.contentSecernId}/edit`
      : '';
    const { hideTopMenu } = getUserQuery();
    const canEditDelete = canAccessRoute(CONTENT_LINK_EDIT);
    const showBackBtn = !shouldHideBackBtn(this.props.location);
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_LINK_LIST}
          text="リンク一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="リンクの詳細" />
        {this.state.contentLink && <ContentLinkDetail contentLink={this.state.contentLink} />}
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Form.Group className="margin-top-20 text-center">
              {this.state.contentLink &&
              !this.state.contentLink.dataAffiliationType &&
              canEditDelete ?
                <Link
                  className="btn btn-primary margin-10 btn-96"
                  role="button"
                  to={editPath}
                >
                編集
              </Link> : null}
              {this.state.contentLink &&
              !this.state.contentLink.dataAffiliationType &&
              canEditDelete ?
                <Button
                  variant="primary"
                  className="margin-10 btn-96"
                  onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_LINK, null)}
                  disabled={!canEditDelete}
                >
                削除
              </Button> : null}
            </Form.Group>
          </Form>
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content, redirectToList: state.content.redirectToList },
});

export default connect(mapStateToProps)(ContentLinkDetailContainer);
